import { setPreference, ReportSlice } from "Components/Report/reportSlice";
import { useAppDispatch } from "store/hook";
import { Typography } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { accountOptions, deviceOptions } from "../../Filter";

const { Title } = Typography;

const grid = 8;

const getItemStyle = (isDragging: any, draggableStyle: any) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 ${grid}px 0`,

  // change background colour if dragging
  background: isDragging ? "lightgreen" : "grey",

  // styles we need to apply on draggables
  ...draggableStyle,
});
const getListStyle = (isDraggingOver: any) => ({
  background: isDraggingOver ? "lightblue" : "lightgrey",
  padding: grid,
  width: 250,
});

const reorder = <T,>(list: T[], startIndex: number, endIndex: number) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const move = <T,>(source: T[], destination: T[], droppableSource: any, droppableDestination: any) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result: any = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};

const store = (data: any, type: "account" | "device") => {
  localStorage.setItem(`report.DnD.${type}Param`, JSON.stringify(data));
};

interface PreferenceOrderProps {
  preference: ReportSlice["preference"];
  type: "account" | "device";
}

const Order = ({ preference, type }: PreferenceOrderProps) => {
  const disp = useAppDispatch();
  const order = preference.order[type];

  const onDragEnd = (result: any) => {
    const { source, destination } = result;
    if (!destination) return;

    const sInd = +source.droppableId;
    const dInd = +destination.droppableId;

    //DnD within the same column
    if (sInd === dInd) {
      const items = reorder(order[sInd], source.index, destination.index);
      const newState = [...order];
      //@ts-ignore
      newState[sInd] = items;
      disp(setPreference({ ...preference, order: { ...preference["order"], [type]: newState } }));
      store(newState, type);
    }
    //Cross columns
    else {
      const result = move(order[sInd], order[dInd], source, destination);
      const newState = [...order];
      newState[sInd] = result[sInd];
      newState[dInd] = result[dInd];

      if (!newState[sInd].length || !newState[dInd].length)
        disp(
          setPreference({
            ...preference,
            column: { ...preference["column"], [type]: 1 },
            order: { ...preference["order"], [type]: newState },
          })
        );
      else disp(setPreference({ ...preference, order: { ...preference["order"], [type]: newState } }));
      store(newState, type);
    }
  };

  return (
    <div>
      <Title level={5} underline>
        Order
      </Title>
      <div style={{ display: "flex" }}>
        <DragDropContext onDragEnd={onDragEnd}>
          {order.map((el, ind) => {
            if (!el.length && preference["column"][type] === 1) return;
            return (
              <Droppable key={ind} droppableId={`${ind}`}>
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}
                    {...provided.droppableProps}
                  >
                    {el.map((item, index) => (
                      <Draggable key={item} draggableId={item} index={index}>
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              {/* {item} */}
                              {[...accountOptions, ...deviceOptions].find((opt) => opt.value === item)?.label}
                            </div>
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            );
          })}
        </DragDropContext>
      </div>
    </div>
  );
};

export default Order;
